import React from 'react';

const ErrorOverlay = ({ message, onConfirm, isButton }) => {
  return (
    <div style={styles.container}>
      <div style={styles.leftVue}>
        <p style={{ ...styles.text, ...styles.title }}>Oops!</p>
        <p style={styles.text}>{message}</p>
      </div>
      {isButton && (
        <button onClick={onConfirm} style={styles.button}>
          Try Again
        </button>
      )}
    </div>
  );
};

export default ErrorOverlay;

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '24px',
    // backgroundColor: '#070B0F',
    height: '100vh',
  },
  leftVue: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  text: {
    textAlign: 'left',
    fontSize: '16px',
    marginBottom: '8px',
    color: '#ea2006',
  },
  title: {
    fontSize: '20px',
    fontWeight: 'bold',
  },
  button: {
    marginTop: '16px',
    padding: '8px 16px',
    fontSize: '18px',
    color: '#fff',
    backgroundColor: '#007BFF',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
};

// import { UI_ERR_OOPS, UI_ERR_TRY_AGAIN } from '../../store/langStrings';

// function ErrorOverlay({ message, onConfirm, isButton }) {
//   return (
//     <div>{UI_ERR_OOPS}</div>
//   );
// }

// export default ErrorOverlay;
